export const openZoomLink = (url) => {
  try {
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (error) {
    window.location.href = url;
  }
};
